import { oc } from '@orpc/contract';
import { saveValuationInputSchema, valuationSnapshotDetailSchema } from '../schemas/valuations.schemas.js';
/**
 * Freezes the current calculation (plan §5.2). It is **refused while anything is missing or blocking** —
 * a snapshot of an unpriceable record would be a number nobody could stand behind — assigns the next
 * `seq` under the owner's row lock, supersedes the previous SAVED row and records `trigger: MANUAL`.
 */
export const saveValuationContract = oc
    .route({
    method: 'POST',
    path: '/valuations',
    tags: ['Valuations'],
    summary: 'Save an immutable valuation snapshot',
})
    .input(saveValuationInputSchema)
    .output(valuationSnapshotDetailSchema);
//# sourceMappingURL=save-valuation.contract.js.map